import { TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import { shadowBlue } from "../../Utils/Constant";
import DocImage from "../../Assets/Images/doc.png";
import PDFImage from "../../Assets/Images/pdf.png";
import VIDImage from "../../Assets/Images/video.png";
import URLImage from "../../Assets/Images/url.png";
import Tooltip from "../../Components/UI/Tooltip/Tooltip";
import { useRemoveCitation } from "../../Web-Hooks/Debate/use-debate";
import { useUserStore } from "../../Context/store";
import { useWorkspaceStore } from "../../Context/store";
import { extractTitle, getFileType, getLocalTime } from "../../Utils/Helper";
import { useFileViewer } from "../../Context/FileViewerContext";
import { useDeleteBlob } from "../../Web-Hooks/LibraryAPI/use-citation";
const CitationList = ({ citation, setCitation }) => {
  const { mutateAsync: removeCitation } = useRemoveCitation();
  const {user: loggedInUser} = useUserStore()
  const {selectedWorkspace} = useWorkspaceStore()
  const {handleFile} = useFileViewer();
  const { mutateAsync: deleteBlob } = useDeleteBlob();


  const handleCitationDelete = async(selectedCitation) => {
    const newCitation = citation.filter(
      (item) => item.citationUrl !== selectedCitation?.citationUrl
    );
    setCitation(newCitation);

    if (selectedCitation?.citationType !== "url") {
      const Blob = { fileUrl: selectedCitation?.citationUrl };
      await deleteBlob(Blob);
    }

    if (selectedCitation?.isCitationFromDatabase) {
      const citationToRemove = {
        CitationId: selectedCitation?.citationId,
        UserId: loggedInUser?.userId,
      };
      if(Object.values(citationToRemove).some(item => item === null || item === undefined || item === "")){
        return;
      }
      removeCitation(citationToRemove)
    }

  };

  const CitationListRender = (item) => {
    const fileType = getFileType(
      `hello.${item?.citationType}`
    );

    const Src =
    fileType === "doc"
      ? DocImage
      : fileType === "pdf"
      ? PDFImage
      : item?.citationType === "url"
      ? URLImage
      : fileType === "video"
      ? VIDImage
      : item?.citationUrl;

      const CitationTitle =  item?.citationTitle ? item?.citationTitle : extractTitle(item?.citationUrl)
      ? extractTitle(item?.citationUrl)
      : item?.citationUrl;
    return (
      <Tooltip
        position="bottom"
        key={item?.citationUrl}
        content={item?.citationNote}
        className="w-full text-debatePalette-background bg-sideLayoutPrimary z-100"
      >
        <div
          className={`flex w-full cursor-pointer items-center px-3 py-2 gap-3 border  rounded-md ${`${shadowBlue}`}`}
        >
          <img
            className="h-8 w-8 rounded-md object-cover object-center cursor-pointer"
            src={Src}
            alt={item?.citationType}
            onClick={(e) => {
              e.preventDefault(); // Prevent default download behavior
              if (item?.citationType === "url") {
                window.open(item?.citationUrl, "_blank");
                return;
              }
              handleFile({
                fileUrl: item?.citationUrl,
                fileType: item?.citationType,
                fileName: CitationTitle,
                fileUploadedAt: getLocalTime(item?.createdAt),
                createdBy: loggedInUser?.userName,
                creatorImage: loggedInUser?.userImage,
                channelName: selectedWorkspace?.workSpaceName,
              });
            }}
          />{" "}
          <p className="truncate w-[60%]">{CitationTitle}</p>
          <div className=" flex flex-1 justify-end">
            <TrashIcon
              className="h-6 w-6  text-debatePalette-timer opacity-50 hover:opacity-100"
              onClick={() => handleCitationDelete(item)}
            />
          </div>
        </div>
      </Tooltip>
    );
  };
  return (
    <div className="flex flex-col gap-3 w-full">
      {citation?.map((item) => CitationListRender(item))}
    </div>
  );
};

export default CitationList;
